import {
  Component,
  OnDestroy,
  OnInit,
  Inject,
  Output,
  EventEmitter,
} from '@angular/core';
import {
  NB_WINDOW,
  NbMediaBreakpointsService,
  NbMenuService,
  NbSidebarService,
  NbThemeService,
} from '@nebular/theme';

import { UserData } from '../../../core/data/users';
import { LayoutService } from '../../../core/utils';
import { map, takeUntil, filter } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';
import { AuthService } from '../../../services/auth.service';
import { Router } from '@angular/router';
import { UtilService } from '../../../services/util.service';
import { EnvService } from '../../../services/env.service';
import { environment } from '../../../../environments/environment';
import { Capacitor } from '@capacitor/core';
import { NetworkService } from '../../../services/network.service';
import { AuthSsoService } from '../../../services/auth-sso.service';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  user: any;
  pegawai: any;
  token: any;
  appName: string = environment.appName;
  env_image: any = this.envService.env.imageUrl;
  @Output() newEvent = new EventEmitter();

  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
  ];

  currentTheme = 'dark';
  isLoggedIn = false;
  userMenu = [{ title: 'Profile' }, { title: 'Logout' }];
  onClickSubs: Subscription;
  isNative = Capacitor.isNativePlatform();

  constructor(
    private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    private userService: UserData,
    private layoutService: LayoutService,
    private breakpointService: NbMediaBreakpointsService,
    private authService: AuthService,
    private router: Router,
    private utilService: UtilService,
    private envService: EnvService,
    public networkService: NetworkService,
    private authSso: AuthSsoService,
    @Inject(NB_WINDOW) private window,
  ) {}

  ngOnInit() {
    this.currentTheme = this.themeService.currentTheme;

    this.userService
      .getUsers()
      .pipe(takeUntil(this.destroy$))
      .subscribe((users: any) => (this.user = users.nick));

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService
      .onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe(
        (isLessThanXl: boolean) => (this.userPictureOnly = isLessThanXl),
      );

    this.themeService
      .onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe((themeName) => (this.currentTheme = themeName));

    if (this.authService.isAuthenticated) {
      this.isLoggedIn = true;
      this.user = this.authService.currentUserValue;
      this.token = this.authService.currentUserValue.api_token;
    }
    this.onClickSubs = this.menuService
      .onItemClick()
      .pipe(
        filter(({ tag }) => tag === 'user-menu'),
        map(({ item: { title } }) => title),
      )
      .subscribe((title) =>
        title === 'Profile'
          ? this.authService.profil()
          : this.authService.logoutPrompt().subscribe((res) => {
              if (res.event) {
                this.authSso.logout();
              }
            }),
      );
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.onClickSubs.unsubscribe();
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(false, 'menu-sidebar');
    // this.layoutService.changeLayoutSize();

    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }

  doRefreshOnParent() {
    this.newEvent.emit();
  }
}
